export default __webpack_public_path__ + "static/media/(29).a4e39d55.jpg";